import styled from '@emotion/styled';

export const Container = styled.div`
  display: grid;
  width: fit-content;
  max-width: 130px;
  height: 32px;
  grid-template-columns: 1fr 16px;
  align-items: center;
  padding: 0 8px 0 12px;
  gap: 8px;
  overflow: hidden;
  border-radius: 24px;
  background: ${({ theme }) => theme.colors.neutral[100]};
  cursor: pointer;

  :hover {
    background: ${({ theme }) => theme.colors.neutral[200]};
  }

  & .user-selected-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;
